export default class Address {
	constructor(addressStatus = "Secondary") {
		this.AddressStatus = addressStatus;

		this.AddressType = null;
		this.Subpremise = null;
		this.Premise = null;
		this.Street = null;
		this.Street2 = null;
		this.Suburb = null;
		this.State = null;
		this.Postcode = null;
		this.Country = null;
		this.FormattedAddress = null;
		this.GooglePlaceJson = null;
		this.Lat = null;
		this.Lng = null;
		this.PlaceId = null;
		this.GoogleMapsUrl = null;
	}
}
